<template>
  <div class="hello">
    <div class="col-sm-12 col-sm-offset-12 loginContain">
      <el-container class="login">
          <el-header height="auto">
            <h1 class="login-header" v-if="!isLoading">Please Log In</h1>
            <h1 class="login-header" v-if="isLoading">Logging In...</h1>
          </el-header>
          <br>
          <div v-loading="isLoading"></div>
          <el-main class="login" v-if="!isLoading">
            <el-alert v-if="errorDescription !== ''"
              class="alert"
              :title="errorTitle"
              :type="alertType"
              :description="errorDescription"
              :closable="false"
              show-icon>
            </el-alert>
            <p>
              <strong>Please Note: Make sure pop ups are enabled for login to the PEA system.</strong>
            </p>
            <el-row type="flex" :gutter="12" justify="center">
                <el-button type="primary" @click="login">Login</el-button>
            </el-row>
          </el-main>
        </el-container>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      isLoading: false,
      alertType: 'error',
      errorDescription: '',
      errorTitle: ''
    }
  },
  methods: {
    async login () {
      this.isLoading = true
      const request = { scopes: ['User.Read.All'] }
      await this.$msalInstance
        .loginPopup(request)
        .then(() => {
          this.errorTitle = ''
          this.errorDescription = ''
          const redirect = this.$route.query.redirect || '/'
          this.$router.push(redirect)
        })
        .catch((error) => {
          this.errorTitle = 'Error logging in'
          this.errorDescription = error
          console.error(error)
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  },
  name: 'login'
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.loginContain{
  text-align: center;
    display: inline-block;
    max-width: 500px;
}
.loginContain h1, .loginContain h2 {
  font-weight: normal;
}

.loginContain ul {
  list-style-type: none;
  padding: 0;
}

.loginContain li {
  display: inline-block;
  margin: 0 10px;
}

.loginContain a {
  color: #42b983;
}

.alert {
  margin-bottom: 20px;
}
</style>
